module.exports = __webpack_public_path__ + "static/tooltip-forms-dont-479dd5a8b5ef06da8d906a0b3674b41e.png";